// Widget Cloudflare Turnstile (TurnstileInput) vykreslí skript Cloudflare sám jen při načtení
// stránky. Když se formulář překreslí AJAXem (chyba validace, registrace), je kontejner nový
// a prázdný - bez ručního vykreslení by nešlo odeslat znovu.

// Widget má appearance interaction-only: dokud Cloudflare nechce interakci, má nulovou výšku
// a okraj obalu (.mb-3 z rendereru formuláře) by po něm nechal prázdnou mezeru nad tlačítkem.
const hideMargin = () => {
    document.querySelectorAll('.cf-turnstile:not([data-shown])').forEach((container) => {
        container.parentElement?.classList.replace('mb-3', 'turnstile-idle');
    });
};

window.wisartTurnstileShow = () => {
    document.querySelectorAll('.cf-turnstile').forEach((container) => {
        container.dataset.shown = '1';
        container.parentElement?.classList.replace('turnstile-idle', 'mb-3');
    });
};

const renderEmpty = () => {
    hideMargin();
    if (!window.turnstile) {
        return;
    }

    document.querySelectorAll('.cf-turnstile').forEach((container) => {
        if (container.childElementCount === 0) {
            window.turnstile.render(container);
        }
    });
};

// Token vydá Cloudflare až 1–2 s po načtení stránky a skrytý widget to nijak neukazuje. Kdo odešle
// formulář dřív (automatické vyplnění hesla + Enter), dostal by „Nepodařilo se ověřit, že nejste robot“
// (27. 10. 2026: 22× za první den, vždy člověk). Odeslání se proto podrží, na tlačítku je „Ověřování…“
// a jakmile token je, formulář se odešle sám. Když token do 10 s nepřijde a Cloudflare nechce
// interakci (např. jeho skript je blokovaný), odešle se i tak – chybu pak řekne server.
const TOKEN_WAIT_MS = 10000;
const hasToken = (form) => Boolean(form.querySelector('[name="cf-turnstile-response"]')?.value);

const setButtonLabel = (button, label) => {
    if (button instanceof HTMLInputElement) {
        button.value = label;
    } else {
        button.textContent = label;
    }
};

const submitWhenToken = (form, submitter) => {
    const button = submitter ?? form.querySelector('[type="submit"]');
    const label = button ? (button instanceof HTMLInputElement ? button.value : button.textContent) : null;
    const start = Date.now();
    form.dataset.turnstileWaiting = '1';
    if (button) {
        setButtonLabel(button, 'Ověřování…');
        button.disabled = true;
    }

    const timer = setInterval(() => {
        const interactive = Boolean(form.querySelector('.cf-turnstile[data-shown]'));
        if (!hasToken(form) && (interactive || Date.now() - start < TOKEN_WAIT_MS)) {
            return;
        }

        clearInterval(timer);
        delete form.dataset.turnstileWaiting;
        if (button) {
            setButtonLabel(button, label);
            button.disabled = false;
        }
        // Bez tokenu (vypršel čas) by se handlery níž zachytily znovu a čekaly dokola
        form.dataset.turnstileReleaseUntil = String(Date.now() + 1000);
        if (button) {
            button.click();
        } else {
            form.requestSubmit();
        }
    }, 200);
};

const holdSubmit = (event, form, submitter) => {
    if (!form || !form.querySelector('.cf-turnstile') || hasToken(form)) {
        return;
    }
    if (Number(form.dataset.turnstileReleaseUntil ?? 0) > Date.now()) {
        return;
    }

    // Capture fáze: zastaví i validaci Nette a AJAX (Naja), znovu je spustí až odeslání s tokenem
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!form.dataset.turnstileWaiting) {
        submitWhenToken(form, submitter);
    }
};

// AJAXové formuláře (obnova hesla, registrace) odesílá Naja už na kliknutí na tlačítko,
// událost submit pak nevznikne – proto i click (Enter v poli spouští taky click na tlačítko).
document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[type="submit"]') : null;
    if (button) {
        holdSubmit(event, button.form, button);
    }
}, true);

document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement) {
        holdSubmit(event, event.target, event.submitter);
    }
}, true);

let scheduled = false;
const init = () => {
    if (!document.querySelector('.cf-turnstile')) {
        return;
    }
    hideMargin();

    new MutationObserver(() => {
        if (scheduled) {
            return;
        }
        scheduled = true;
        requestAnimationFrame(() => {
            scheduled = false;
            renderEmpty();
        });
    }).observe(document.body, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
